import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { AppContext } from 'context';
import Account from 'modules/Account';
import App from 'modules/App';
import { activePatient as activePatientSelector } from 'modules/Hcp/selectors';
import Visit from 'modules/Visit';
import Link from 'components/Link';
import { useAction } from 'hooks';
import styles from '../NotificationsPopover.pcss';
const useLinkRendereres = ()=>{
    const context = useContext(AppContext);
    const hcpProfile = useSelector(Account.selectors.hcpProfile);
    const activePatient = useSelector(activePatientSelector);
    const openVisitsModal = useAction(App.actions.openModal, Visit.constants.VISIT_HISTORY_MODAL);
    const getFamilyMemberLink = (variables, messageValue)=>{
        const { familyLinkId, patientSlug } = variables;
        return /*#__PURE__*/ _jsx(Link, {
            to: context.getUrl('family-member-results', {
                patientSlug,
                familyLinkId
            }),
            children: messageValue
        });
    };
    const getPatientProfileLink = (variables, messageValue)=>{
        const { clinicSlug, patientSlug, patientId, organizationUID } = variables;
        if (!patientId || !organizationUID || !clinicSlug || !patientSlug) {
            return `#${messageValue}`;
        }
        return /*#__PURE__*/ _jsx(Link, {
            to: context.getUrl('hcp-results', {
                clinicSlug,
                organizationUID,
                patientSlug,
                patientId
            }),
            children: messageValue
        });
    };
    const getClinicLink = (variables, messageValue)=>{
        const { organizationUID, clinicSlug } = variables;
        if (!organizationUID) {
            return `#${messageValue}`;
        }
        return /*#__PURE__*/ _jsx(Link, {
            to: `${context.getUrl('clinic-settings', {
                clinicSlug,
                organizationUID
            })}#clinicMemberships`,
            children: messageValue
        });
    };
    const getVisitNotesLink = (variables, messageValue)=>{
        const { patientProfileId, patientId, clinicSlug, patientSlug, organizationUID } = variables;
        const OpenVisitsModalSpan = // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        /*#__PURE__*/ _jsx("span", {
            className: styles.notifications__link,
            onClick: openVisitsModal,
            children: messageValue
        });
        if (!hcpProfile || activePatient && activePatient.id === patientProfileId) {
            return OpenVisitsModalSpan;
        }
        const hcpResultsUrl = context.getUrl('hcp-results', {
            clinicSlug,
            organizationUID,
            patientSlug,
            patientId
        });
        return /*#__PURE__*/ _jsx(Link, {
            to: `${hcpResultsUrl}?openModalId=${Visit.constants.VISIT_HISTORY_MODAL}`,
            children: messageValue
        });
    };
    return {
        FamilyMemberLink: (instantNotification, messageValue)=>getFamilyMemberLink(instantNotification, messageValue),
        PatientProfileLink: (instantNotification, messageValue)=>getPatientProfileLink(instantNotification, messageValue),
        ClinicLink: (instantNotification, messageValue)=>getClinicLink(instantNotification, messageValue),
        VisitNotesLink: (instantNotification, messageValue)=>getVisitNotesLink(instantNotification, messageValue)
    };
};
export default useLinkRendereres;
